module.exports = __webpack_public_path__ + "img/D201803_2.6a9be80e.jpg";